var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebcamDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "-3 -4 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.8857V23.7897C2.00968 25.9016 2.85805 27.923 4.35841 29.4092C5.85877 30.8955 7.88817 31.7246 10 31.7143H26C28.1118 31.7246 30.1412 30.8955 31.6416 29.4092C33.142 27.923 33.9903 25.9016 34 23.7897V13.8857C33.9903 11.7739 33.142 9.75245 31.6416 8.26623C30.1412 6.78001 28.1118 5.95083 26 5.96116C24.8908 5.81404 23.9432 5.08914 23.5109 4.05716C22.8021 2.78366 21.4574 1.99576 20 2.00002H16C14.5426 1.99576 13.1979 2.78366 12.4891 4.05716C12.0568 5.08914 11.1092 5.81404 10 5.96116C7.88817 5.95083 5.85877 6.78001 4.35841 8.26623C2.85805 9.75245 2.00968 11.7739 2 13.8857Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0008 23.7897C15.2714 23.7632 13.0778 21.5336 13.0958 18.8041C13.1138 16.0746 15.3367 13.8741 18.0662 13.8837C20.7958 13.8932 23.0031 16.1093 23.002 18.8388C22.9953 20.1586 22.4647 21.4216 21.5268 22.3501C20.5889 23.2785 19.3206 23.7964 18.0008 23.7897Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcamDark);
export default __webpack_public_path__ + "static/media/webcam-dark.d45d60ab3517143aa83ff6defa031bf1.svg";
export { ForwardRef as ReactComponent };